import axios from "axios";

export async function getCoordCity(city: string, uf: string) {
  const params = new URLSearchParams({
    city,
    state: uf,
    country: "Brasil",
    format: "json",
    limit: "1",
  });
  const url = `https://nominatim.openstreetmap.org/search?${params.toString()}`;

  try {
    const response = await axios.get(url);
    if (response.data.length > 0) {
      const { lat, lon } = response.data[0];
      const coords = [parseFloat(lat), parseFloat(lon)];

      return coords;
    }
  } catch (error) {}
  return null;
}
